var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, OnDestroy } from '@angular/core';
import { Store, Select, Actions, ofActionDispatched } from '@ngxs/store';
import { AuthState } from 'src/app/auth/state/auth/auth.state';
import { Observable, Subject, of } from 'rxjs';
import { filter, takeUntil, flatMap, delay } from 'rxjs/operators';
import { Logout, LogoutSuccess, GetUserProfile, SetSelectedUserApp, GetUserApps, SetUserMessageViewed } from 'src/app/auth/state/auth/auth.actions';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { LegacyMessageService, LegacyEventsEnum } from '../../legacy-message.service';
import { DialogService } from 'src/app/dialogs/dialog.service';
import { UserMessageEnum } from 'src/app/auth/models/user-message-model';
import { JoinOrganizationSuccess } from 'src/app/organizations/state/organizations.actions';
import { UserMessageService } from '../../user-message.service';
var UserProfilePinComponent = /** @class */ (function () {
    function UserProfilePinComponent(store, router, actions, dialog, legacyService, dialogService, userMessageService) {
        this.store = store;
        this.router = router;
        this.actions = actions;
        this.dialog = dialog;
        this.legacyService = legacyService;
        this.dialogService = dialogService;
        this.userMessageService = userMessageService;
        this.initials = '';
        this.isPremiumAccount = false;
        this.isGroupAccount = false;
        this.ngUnsubscribe = new Subject();
    }
    UserProfilePinComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Get user profile
        this.userProfile$
            .pipe(filter(function (profile) { return profile != null; }), takeUntil(this.ngUnsubscribe))
            .subscribe(function (profile) {
            _this.initials = _this.getInitials(profile);
            // user account type
            _this.isPremiumAccount = profile.premium_account;
            _this.isGroupAccount = profile.organizations && profile.organizations.length > 0;
        });
        // User logs out
        this.actions
            .pipe(ofActionDispatched(LogoutSuccess), takeUntil(this.ngUnsubscribe))
            .subscribe(function () {
            _this.router.navigate(['/login']);
        });
        // handle user message queue
        this.initUserMessaging();
        // handle legacy messages
        this.initLegacyRouting();
    };
    UserProfilePinComponent.prototype.initUserMessaging = function () {
        var _this = this;
        // First time logging in
        this.getUserMessage(UserMessageEnum.WelcomeTour, 1000, 'v2')
            .pipe(flatMap(function () {
            return _this.getUserMessage(UserMessageEnum.DomainAlert, 1000);
        }))
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe();
        // User joined group
        this.actions
            .pipe(ofActionDispatched(JoinOrganizationSuccess), takeUntil(this.ngUnsubscribe))
            .subscribe(function () {
            _this.showGroupUpgradeDialog();
        });
    };
    /**
     * Manage legacy user events/messages
     */
    UserProfilePinComponent.prototype.initLegacyRouting = function () {
        var _this = this;
        // handle profile updates
        this.legacyService.onEvent(LegacyEventsEnum.ProfileUpdated)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (e) {
            _this.store.dispatch(new GetUserProfile());
        });
        // handle account delete
        this.legacyService.onEvent(LegacyEventsEnum.ProfileDeleted)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function () { return _this.handleLogout(); });
        // handle buy subscription
        this.legacyService.onEvent(LegacyEventsEnum.ShowCheckoutDialog)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function () { return _this.handleBuySubscription(); });
        // handle upgrade request
        this.legacyService.onEvent(LegacyEventsEnum.ShowUpgradeDialog)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function () { return _this.handleUpgradeSubscription(); });
        // upgraded: to pro
        this.legacyService.onEvent(LegacyEventsEnum.UserIsActiveProfessional)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (e) {
            _this.showPremiumUpgradeDialog();
        });
        // upgraded: to enterprise (group)
        this.legacyService.onEvent(LegacyEventsEnum.UserIsActiveEnterprise)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (e) {
            _this.showGroupUpgradeDialog();
        });
        // deleted: handle user deleted    
        this.legacyService.onEvent(LegacyEventsEnum.ProfileDeleted)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function () { return _this.handleProfileDeleted(); });
        // handle close dialog
        this.legacyService.onEvent(LegacyEventsEnum.CloseDialogBoxMessage)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function () { return _this.dialog.closeAll(); });
        // developer app selection
        this.legacyService.onEvent(LegacyEventsEnum.DeveloperAppSelected)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (e) {
            var selectedAppId = e.eventData ? parseInt(e.eventData, 10) : null;
            // sync apps
            _this.store.dispatch(new GetUserApps());
            // select app id        
            _this.store.dispatch(new SetSelectedUserApp(selectedAppId));
        });
    };
    UserProfilePinComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    UserProfilePinComponent.prototype.handleLogout = function () {
        this.store.dispatch(new Logout());
    };
    UserProfilePinComponent.prototype.handleProfile = function () {
        this.showProfile();
    };
    UserProfilePinComponent.prototype.handleProfileDeleted = function () {
        this.dialog.closeAll();
        var dialogRef = this.dialogService.openConfirmDialog({
            data: {
                titleText: 'Account Deleted',
                bodyText: 'Your account has been successfully deleted.',
                confirmText: 'Logout',
                confirmColor: 'warn',
                cancelEnabled: false
            }
        });
        dialogRef.afterClosed()
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function () {
            window.location.reload();
        });
    };
    UserProfilePinComponent.prototype.handleGroupAccount = function () {
        this.showProfile('groups');
    };
    UserProfilePinComponent.prototype.handleDeveloperAccount = function () {
        this.showProfile('developer');
    };
    UserProfilePinComponent.prototype.handleUpgradeSubscription = function () {
        this.dialogService.openUpgradeDialog();
    };
    UserProfilePinComponent.prototype.handleBuySubscription = function () {
        this.dialogService.openBuyDialog();
    };
    UserProfilePinComponent.prototype.handleAbout = function () {
        this.dialogService.openAboutDialog();
    };
    UserProfilePinComponent.prototype.getInitials = function (userProfile) {
        if (userProfile.first_name) {
            return userProfile.first_name.substr(0, 1);
        }
        if (userProfile.email) {
            return userProfile.email.substr(0, 1);
        }
        return '';
    };
    UserProfilePinComponent.prototype.showProfile = function (section) {
        this.dialogService.openProfileDialog(null, section);
    };
    UserProfilePinComponent.prototype.showPremiumUpgradeDialog = function () {
        this.showAccountUpgradeDialog('You have successfuly upgraded to a Premium Account. Reload to reflect changes?');
    };
    UserProfilePinComponent.prototype.showGroupUpgradeDialog = function () {
        this.showAccountUpgradeDialog('You have successfuly joined a group. Reload to reflect changes?');
    };
    UserProfilePinComponent.prototype.showAccountUpgradeDialog = function (text) {
        this.dialog.closeAll();
        var dialogRef = this.dialogService.openConfirmDialog({
            data: {
                titleText: 'Account Upgraded',
                bodyText: text,
                confirmText: 'Reload',
                confirmColor: 'warn',
                cancelEnabled: false
            }
        });
        dialogRef.afterClosed()
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (confirmed) {
            if (confirmed) {
                window.location.reload();
            }
        });
    };
    /**
     * Manages user messaging queue
     */
    UserProfilePinComponent.prototype.getUserMessage = function (message, delayAmount, mode) {
        var _this = this;
        if (delayAmount === void 0) { delayAmount = 0; }
        if (mode === void 0) { mode = ''; }
        return this.userMessageService.getUserMessage(message, mode)
            .pipe(
        // Allow delay between messages so that we don't spam the user
        delay(delayAmount), 
        // Parse message data
        flatMap(function (_a) {
            var showUserAlert = _a.showUserAlert, messageData = _a.messageData, messageSeenId = _a.messageSeenId;
            if (showUserAlert && messageData) {
                // Log dialog shown so we don't show repeats
                _this.store.dispatch(new SetUserMessageViewed(messageSeenId));
                // Handle which dialog to show
                switch (message) {
                    case UserMessageEnum.WelcomeTour:
                        return _this.dialogService.openWelcomeTourDialog(messageData).afterClosed();
                    case UserMessageEnum.DomainAlert:
                        return _this.dialogService.openJoinDomainDialog(messageData).afterClosed();
                }
            }
            else {
                return of(false);
            }
        }));
    };
    __decorate([
        Select(AuthState.getLoggedIn),
        __metadata("design:type", Observable)
    ], UserProfilePinComponent.prototype, "loggedIn$", void 0);
    __decorate([
        Select(AuthState.getUserProfile),
        __metadata("design:type", Observable)
    ], UserProfilePinComponent.prototype, "userProfile$", void 0);
    return UserProfilePinComponent;
}());
export { UserProfilePinComponent };
